export const ADD_TICKET_IN_TICKET_LIST = 'ADD_TICKET_IN_TICKET_LIST';
export const ATTACH_ORDER_TO_TICKET = 'ATTACH_ORDER_TO_TICKET';
export const CLOSE_TICKET = 'CLOSE_TICKET';
export const CLOSE_TICKET_SUCCESS = 'CLOSE_TICKET_SUCCESS';
export const CREATE_TICKET = 'CREATE_TICKET';
export const CREATE_TICKET_FINISH = 'CREATE_TICKET_FINISH';
export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const DELETE_TICKET_FROM_TICKET_LIST = 'DELETE_TICKET_FROM_TICKET_LIST';
export const DETACH_ORDER_FROM_TICKET = 'DETACH_ORDER_FROM_TICKET';
export const FETCH_TICKETS = 'FETCH_TICKETS';
export const FETCH_TICKETS_FAILURE = 'FETCH_TICKETS_FAILURE';
export const SET_EXCESS_TICKETS = 'SET_EXCESS_TICKETS';
export const INPUT_DESTINATION = 'INPUT_DESTINATION';
export const INPUT_SUGGESTED_ORDERS = 'INPUT_SUGGESTED_ORDERS';
export const RESET_TICKET_ERRORS = 'RESET_TICKET_ERRORS';
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const SELECT_TICKET = 'SELECT_TICKET';
export const SET_CLIENTS_OPTIONS = 'SET_CLIENTS_OPTIONS';
export const SET_CLOSE_REASONS_OPTIONS = 'SET_CLOSE_REASONS_OPTIONS';
export const SET_COUNTRIES_OPTIONS = 'SET_COUNTRIES_OPTIONS';
export const SET_DEPARTURE_OPTIONS = 'SET_DEPARTURE_OPTIONS';
export const SET_MAIL_GROUP_OPTIONS = 'SET_MAIL_GROUP_OPTIONS';
export const SET_SKILL_GROUP_OPTIONS = 'SET_SKILL_GROUP_OPTIONS';
export const SET_MANAGER_OPTIONS = 'SET_MANAGER_OPTIONS';
export const SET_ORDER_SEGMENT_OPTIONS = 'SET_ORDER_SEGMENT_OPTIONS';
export const SET_PAGE = 'SET_PAGE';
export const SET_PARTNER_OPTIONS = 'SET_PARTNER_OPTIONS';
export const SET_REASON_OPTIONS = 'SET_REASON_OPTIONS';
export const SET_SOURCE_OPTIONS = 'SET_SOURCE_OPTIONS';
export const SET_MENU_SOURCE_OPTIONS = 'SET_MENU_SOURCE_OPTIONS';
export const SET_STATUSES_OPTIONS = 'SET_STATUSES_OPTIONS';
export const SET_TAG_OPTIONS = 'SET_TAG_OPTIONS';
export const SET_TEMPLATE_OPTIONS = 'SET_TEMPLATE_OPTIONS';
export const SET_LABEL_OPTIONS = 'SET_LABEL_OPTIONS';
export const SET_PLAN_REASONS_OPTIONS = 'SET_PLAN_REASONS_OPTIONS';
export const SET_TICKET = 'SET_TICKET';
export const SET_TICKET_CLIENT = 'SET_TICKET_CLIENT';
export const SET_TICKET_FILTERS = 'SET_TICKET_FILTERS';
export const SET_TICKET_RELATIVES = 'SET_TICKET_RELATIVES';
export const SET_TICKET_SUGGESTED_ORDERS = 'SET_TICKET_SUGGESTED_ORDERS';
export const SET_TICKET_UPDATED_CLIENT = 'SET_TICKET_UPDATED_CLIENT';
export const SET_IS_LOADING_ACTIVE_TICKET = 'SET_IS_LOADING_ACTIVE_TICKET';
export const SET_TICKETS = 'SET_TICKETS';
export const SET_CLIENT_ATTACHMENTS = 'SET_CLIENT_ATTACHMENTS';
export const SET_TOUR_SELECTION = 'SET_TOUR_SELECTION';
export const TRIGGER_NEW_TICKET = 'TRIGGER_NEW_TICKET';
export const WS_UPDATE_ACTIVE_TICKET = 'WS_UPDATE_ACTIVE_TICKET';
export const SET_ACTIVE_TICKET_INFO = 'SET_ACTIVE_TICKET_INFO';
export const UPDATE_TICKET = 'UPDATE_TICKET';
export const UPDATE_TICKET_CLIENT = 'UPDATE_TICKET_CLIENT';
export const UPDATE_TICKET_IN_TICKET_LIST = 'UPDATE_TICKET_IN_TICKET_LIST';
export const WS_UPDATE_TICKET_IN_TICKET_LIST =
  'WS_UPDATE_TICKET_IN_TICKET_LIST';
export const UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT =
  'UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT';
export const WS_UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT =
  'WS_UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT';
export const UPDATE_TICKET_OWN_ORDERS = 'UPDATE_TICKET_OWN_ORDERS';
export const UPDATE_TICKET_RELATIVES = 'UPDATE_TICKET_RELATIVES';
export const SET_TICKETS_TAB = 'SET_TICKETS_TAB';
export const SET_TICKETS_SORT = 'SET_TICKETS_SORT';
export const RESERVE_TICKET = 'RESERVE_TICKET';
export const SUCCESS_TICKET_RESERVATION = 'SUCCESS_TICKET_RESERVATION';
export const FAIL_TICKET_RESERVATION = 'FAIL_TICKET_RESERVATION';
export const SET_CURRENT_MANAGER_TO_INITIAL_FILTERS =
  'SET_CURRENT_MANAGER_TO_INITIAL_FILTERS';
export const CLEAR_TICKET_FILTERS = 'CLEAR_TICKET_FILTERS';

export const fetchTickets = () => ({ type: FETCH_TICKETS });

export const closeTicket = payload => ({ payload, type: CLOSE_TICKET });

export const resetErrors = () => ({ type: RESET_TICKET_ERRORS });

export const selectTicket = payload => ({ payload, type: SELECT_TICKET });

export const setPage = payload => ({ payload, type: SET_PAGE });

export const setTickets = payload => ({ payload, type: SET_TICKETS });

export const updateClient = payload => ({
  payload,
  type: UPDATE_TICKET_CLIENT,
});

export const updateTicket = payload => ({ payload, type: UPDATE_TICKET });

export const setFilters = payload => ({ payload, type: SET_TICKET_FILTERS });

export const createTicket = payload => ({ payload, type: CREATE_TICKET });

export const selectClient = payload => ({ payload, type: SELECT_CLIENT });

export const createTicketRequest = payload => ({
  payload,
  type: CREATE_TICKET_REQUEST,
});

export const reserveTicket = payload => ({ payload, type: RESERVE_TICKET });

export const inputSuggestedOrders = ({ query }) => ({
  payload: { query },
  type: INPUT_SUGGESTED_ORDERS,
});

export const attachOrderToTicket = ({ orderId }) => ({
  payload: { orderId },
  type: ATTACH_ORDER_TO_TICKET,
});

export const detachOrderFromTicket = ({ orderId }) => ({
  payload: { orderId },
  type: DETACH_ORDER_FROM_TICKET,
});

export const setTicketsTab = ({ tab }) => ({
  payload: { tab },
  type: SET_TICKETS_TAB,
});

export const setTicketsSort = sort => ({
  payload: { sort },
  type: SET_TICKETS_SORT,
});

export const clearTicketFilters = payload => ({
  payload,
  type: CLEAR_TICKET_FILTERS,
});
